"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _form = _interopRequireDefault(require("./form.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

//  Base form component
// ====================
var Form = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Form, _React$Component);

  function Form() {
    (0, _classCallCheck2["default"])(this, Form);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Form).apply(this, arguments));
  }

  (0, _createClass2["default"])(Form, [{
    key: "render",
    value: function render() {
      var classNames = (0, _classnames["default"])(_form["default"].Form, this.props.className);
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          id = _this$props.id,
          action = _this$props.action,
          children = _this$props.children,
          restProps = (0, _objectWithoutProperties2["default"])(_this$props, ["onSubmit", "id", "action", "children"]);
      return _react["default"].createElement("form", (0, _extends2["default"])({
        className: classNames,
        onSubmit: onSubmit,
        id: id,
        action: action
      }, restProps), children);
    }
  }]);
  return Form;
}(_react["default"].Component);

exports["default"] = Form;
Form.propTypes = {
  action: _propTypes["default"].string,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string,
  onSubmit: _propTypes["default"].func,
  children: _propTypes["default"].node
};